import { sendEvent, sendError } from 'shared/bi/bi-facade';

export function createSender(state) {
  const biDefaultParams = getBiDefaultParams(state);
  return (name, params) => sendEvent(name, { ...biDefaultParams, ...params });
}

export function createErrorSender(state) {
  const biDefaultParams = getBiDefaultParams(state);
  return (name, params) => sendError(name, { ...biDefaultParams, ...params });
}

export function getBiDefaultParams(state) {
  return _.mapValues(state.biDefaultParams, value => (_.isFunction(value) ? value(state) : value));
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-with-state-defaults.js